import React, { FC, Fragment, ReactNode } from 'react';
import { useParams, useMatch } from 'react-router-dom';

import { UserFeedFollowGroupFragment } from 'api';
import { Desktop, Mobile } from 'components';
import * as paths from 'paths';
import { useFollowed } from 'hooks';

import SelectMobile from '../components/SelectMobile';
import SelectDesktop from '../components/SelectDesktop';

interface IProps {
  menu?: ReactNode;
}

const Select: FC<IProps> = ({ menu, children }) => {
  const { groups } = useFollowed();
  const isIndex = !!useMatch(paths.index);
  const params = useParams<{ group_id: string }>();

  function isHomeSelected() {
    return isIndex;
  }

  function isGroupSelected(group: UserFeedFollowGroupFragment) {
    const { group_id } = params;
    return group.id === group_id;
  }

  const selectProps = {
    groups,
    menu,
    isHomeSelected,
    isGroupSelected,
    children,
  };

  return (
    <Fragment>
      <Desktop>
        <SelectDesktop {...selectProps} />
      </Desktop>
      <Mobile>
        <SelectMobile {...selectProps} />
      </Mobile>
    </Fragment>
  );
};

export default Select;
